import type { FieldSpecOf } from 'v5/core/entity-schema/entitySchema.types';
import type { FieldCodec } from 'v5/core/entity-values/values.types';
import { customFieldColumns } from './customFieldColumns';
import { findCustomFieldRowForRead } from './customFieldRows';
import { validateField, validation } from './validation';

function isEmpty(value: string): boolean {
  return value === '';
}

/**
 * Plain text: a core scalar column (`nick_name`, `role`) or a SHORT_TEXT /
 * LONG_TEXT custom field, decided by `spec.source`.
 */
export const textCodec: FieldCodec<'text'> = {
  decode(entity, spec, ctx) {
    if (spec.source.type === 'core') {
      return entity[spec.source.column] ?? '';
    }
    const row = findCustomFieldRowForRead(
      entity,
      spec.source.definition.id,
      ctx
    );
    return row?.string_value ?? '';
  },
  encode(value, spec) {
    if (spec.source.type === 'core') {
      return {
        type: 'core-changes',
        changes: [{ column: spec.source.column, value }]
      };
    }
    return {
      type: 'custom',
      columns: customFieldColumns({ string_value: value })
    };
  },
  empty() {
    return '';
  },
  isEmpty,
  validate(value, spec: FieldSpecOf<'text'>) {
    return validateField(value, spec, isEmpty, () => validation.valid());
  }
};
